export default "__VITE_ASSET__TaGE_ebU__"